export const GENERATION_STEP_NAMES = [
    'searching',
    'thinking',
    'answering',
];
export function normalizeGenerationStepName(name) {
    return name.toLowerCase();
}
export const GENERATION_TOOL_CALL_TYPES = ['search', 'generic'];
export function getGeneratedAnswerInitialState() {
    return {
        id: '',
        isVisible: true,
        isEnabled: true,
        isLoading: false,
        isStreaming: false,
        citations: [],
        liked: false,
        disliked: false,
        responseFormat: {
            contentFormat: ['text/plain'],
        },
        feedbackModalOpen: false,
        feedbackSubmitted: false,
        fieldsToIncludeInCitations: [],
        isAnswerGenerated: false,
        expanded: false,
        cannotAnswer: false,
        answerApiQueryParams: undefined,
        answerId: undefined,
        answerGenerationMode: 'automatic',
        generationSteps: [],
    };
}
